// Catálogo de disparadores agrupados por intención.
// Espejo de EVENT_GROUPS en TriggerEditor.vue · usado por el selector inline
// "+ Disparador" de la lista de Salesbots (Index.vue). El editor mantiene su
// copia local intacta a propósito (no se refactoriza para no arriesgar el
// flujo de edición ya estable).
//
// `soon: true` → opción aún no operativa (se muestra deshabilitada).

export const TRIGGER_GROUPS = [
  {
    key: 'new_lead',
    label: 'Cuando un lead NUEVO llega',
    icon: '🚀',
    options: [
      { key: 'first_message', icon: '💬', label: 'Primer mensaje en WhatsApp / IG / canal', trigger_type: 'message_received', extra: { first_message: true } },
      { key: 'email_received', icon: '📧', label: 'Email recibido', trigger_type: 'message_received', extra: { channel: 'email' } },
      { key: 'form_submitted', icon: '📝', label: 'Formulario web enviado', trigger_type: 'webhook', extra: { event: 'form_submit' } },
      { key: 'lead_created', icon: '🆕', label: 'Lead creado en una etapa', trigger_type: 'stage_created', extra: {} },
      { key: 'lead_created_or_moved', icon: '📍', label: 'Lead creado o movido a una etapa', trigger_type: 'stage_any', extra: {} },
      { key: 'ig_mention', icon: '📸', label: 'Mención en historia de Instagram', trigger_type: 'message_received', extra: { source: 'instagram_story_mention' } },
    ],
  },
  {
    key: 'lead_advances',
    label: 'Cuando un lead AVANZA',
    icon: '🏃',
    options: [
      { key: 'stage_changed', icon: '➡️', label: 'Lead movido a una etapa', trigger_type: 'stage_changed', extra: {} },
      { key: 'message_in_stage', icon: '✍️', label: 'Lead escribe estando en una etapa', trigger_type: 'message_received', extra: {} },
      { key: 'first_message_in_stage', icon: '🎯', label: 'Primer mensaje del cliente en una etapa', trigger_type: 'message_received', extra: { first_in_stage: true } },
      { key: 'tag_added', icon: '🏷️', label: 'Etiqueta agregada al lead', trigger_type: 'tag_added', extra: {} },
      { key: 'field_updated', icon: '📋', label: 'Campo del lead actualizado', trigger_type: 'webhook', extra: { event: 'field_updated' }, soon: true },
    ],
  },
  {
    key: 'lead_cold',
    label: 'Cuando un lead se ENFRÍA',
    icon: '❄️',
    options: [
      { key: 'no_response_hours', icon: '💤', label: 'N horas sin respuesta del cliente', trigger_type: 'webhook', extra: { event: 'idle_hours' }, soon: true },
      { key: 'no_activity_days', icon: '⏳', label: 'N días sin actividad', trigger_type: 'webhook', extra: { event: 'idle_days' }, soon: true },
      { key: 'closed_ago', icon: '✅', label: 'Conversación cerrada hace N tiempo', trigger_type: 'webhook', extra: { event: 'resolved_ago' }, soon: true },
    ],
  },
  {
    key: 'client_action',
    label: 'Acción puntual del cliente',
    icon: '📞',
    options: [
      { key: 'call_received', icon: '📞', label: 'Llamada recibida / perdida', trigger_type: 'webhook', extra: { event: 'missed_call' }, soon: true },
      { key: 'message_read', icon: '👁️', label: 'Mensaje saliente leído por el cliente', trigger_type: 'webhook', extra: { event: 'message_read' }, soon: true },
      { key: 'comment_post', icon: '💭', label: 'Comentario en post de IG/FB', trigger_type: 'message_received', extra: { comment_only: true } },
      { key: 'website_visit', icon: '🌐', label: 'Sitio web visitado', trigger_type: 'webhook', extra: { event: 'website_visit' }, soon: true },
      { key: 'assignee_changed', icon: '👤', label: 'Responsable cambiado', trigger_type: 'webhook', extra: { event: 'assignee_changed' }, soon: true },
    ],
  },
  {
    key: 'scheduled',
    label: 'Recordatorios programados',
    icon: '⏰',
    options: [
      { key: 'specific_date', icon: '📅', label: 'En fecha y hora específica', trigger_type: 'webhook', extra: { event: 'specific_date' }, soon: true },
      { key: 'daily', icon: '🔁', label: 'Diariamente a una hora', trigger_type: 'webhook', extra: { event: 'daily' }, soon: true },
      { key: 'before_event', icon: '🎂', label: 'N días antes de cumpleaños / evento', trigger_type: 'webhook', extra: { event: 'before_event' }, soon: true },
    ],
  },
];

// Construye el payload para BotsAPI.createTrigger a partir de una opción del
// catálogo. La config fina (condiciones, horarios) se ajusta luego en el editor.
export function buildTriggerPayload(option) {
  return {
    trigger_type: option.trigger_type || 'message_received',
    config: {
      event_key: option.key,
      ...(option.extra || {}),
      conditions: [],
    },
    active: true,
  };
}
